var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends-container"},_vm._l((_vm.friends),function(friend){return _c('div',{key:friend.steamid,staticClass:"friend-container"},[_c('Friend',{attrs:{"friend":friend},on:{"addFriend":_vm.addFriend}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }